import React, { useEffect, useState } from 'react';
import { Select, Option, Flex } from '@pega/cosmos-react-core';
import { useDispatch, useSelector } from 'react-redux';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { setChatInfo, updateBannerInfo, updateLoaderDetails } from '../../../../redux/actions';
import { appState } from '../../../../interfaces/common';
import { useNavigate } from 'react-router-dom';
import { updateInputAreaOption } from '../ChatApis';

const QuickReplyConfig: React.FC = () => {
  const [textAreaOption, setTextAreaOption] = useState('');
  const translate = useLocalTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    chatInfo: { connectionId, inputTextAreaState },
    sessionId,
  } = useSelector((state: appState) => {
    return {
      chatInfo: state.chatInfo,
      sessionId: state.sessionId,
    };
  });

  useEffect(() => {
    if (inputTextAreaState) setTextAreaOption(inputTextAreaState);
  }, [inputTextAreaState]);

  const updateTextAreaConfig = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedInputAreaOption = e.target.value;
    dispatch(updateLoaderDetails(true));
    const payload = {
      inputTextAreaState: selectedInputAreaOption,
    };
    const json = await updateInputAreaOption(sessionId, connectionId, payload);
    dispatch(updateLoaderDetails(false));
    if (json?.status === 200) {
      dispatch(setChatInfo(json?.data));
      setTextAreaOption(selectedInputAreaOption);
      dispatch(updateBannerInfo(translate('text_input_area_update_success'), 'success'));
    } else if (json?.status === 403) {
      navigate('/');
      dispatch(updateBannerInfo(translate('invalid_session'), 'urgent'));
    } else {
      dispatch(updateBannerInfo(translate('text_input_area_update_failed'), 'urgent'));
    }
  };

  return (
    <Flex
      container={{
        direction: 'row',
        alignItems: 'start',
        itemGap: 0.5,
      }}
    >
      <Flex item={{ grow: 0.01 }}>
        <Select label={translate('input_textarea_config')} value={textAreaOption} onChange={updateTextAreaConfig}>
          <Option value="enable_input">{translate('enable_input')}</Option>
          <Option value="enable_input_conditional">{translate('enable_input_conditional')}</Option>
          <Option value="disable_input">{translate('disable_input')}</Option>
        </Select>
      </Flex>
    </Flex>
  );
};

export default QuickReplyConfig;
